import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../services/administrator/admin.service';
import { IDoaLog } from '../../../interface/administrator/admin';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MaterialModule } from '../../../shared/module/material.module';
import { SharedServices } from '../../../shared/services/shared.services';
 
@Component({
  selector: 'app-doa-log-report',
  imports: [FormsModule, CommonModule, MaterialModule],
  templateUrl: './doa-log-report.component.html',
  styleUrls: ['./doa-log-report.component.css'],
})
export class DoaLogReportComponent implements AfterViewInit {
  tempSelectedOption: string = 'employee';
  selectedOption: string = 'employee';
  tempCai: string = '';
  cai: string = '';
  logs: IDoaLog[] = [];
  employeeCai: string = '';
  employeeName: string = '';
  showLogs: boolean = false;
  showError: boolean = false;
  isLoading: boolean = false;
  ExcelLoading: boolean = false;
  shouldUpdate: boolean = false;
 
  private paginator!: MatPaginator;
  dataSource = new MatTableDataSource<IDoaLog>();
 
  constructor(private adminService: AdminService, private router: Router, public dialog: MatDialog, private sharedService: SharedServices) { }
 
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
 
  ngOnInit(): void { }
 
  ngAfterViewInit(): void {
    this.setDataSourceAttributes();
  }
 
  setDataSourceAttributes() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }
 
  getTitle(): string {
    return this.tempSelectedOption === 'employee' ? 'Employee No' : 'Email';
  }
 
  onGoClick() {
    this.selectedOption = this.tempSelectedOption;
    this.cai = this.tempCai;
    this.showLogs = false;
    this.showError = false;
    this.isLoading = true;
    this.shouldUpdate = true;

    if (!this.cai) {
        this.showError = true;
        this.isLoading = false;
        if (this.selectedOption === 'employee') {
            this.sharedService.openModal('Message', 'Employee number is required');
        } else {
            this.sharedService.openModal('Message', 'Email is required');
        }
        return;
    }

    if (this.selectedOption === 'employee') {
        this.adminService.getEmployeeDetails(this.cai).subscribe(details => {
            if (details && details.employeeNo) {
                this.employeeCai = details.employeeNo;
                this.employeeName = details.name;
            } else {
                this.employeeCai = this.cai;
                this.employeeName = '';
            }
            this.adminService.getEmployeeLogs(this.cai).subscribe(data => {
                this.logs = data;
                this.dataSource.data = data;
                this.setDataSourceAttributes();
                this.isLoading = false;
                this.showLogs = true;
            }, error => {
                this.isLoading = false;
            });
        });
    } else {
        this.adminService.getUserDetails(this.cai).subscribe(details => {
            if (details) {
                this.employeeCai = details.cai;
                this.employeeName = details.name;
            } else {
                this.employeeCai = this.cai;
                this.employeeName = '';
            }
            this.adminService.getUserLogs(this.cai).subscribe(data => {
                this.logs = data;
                this.dataSource.data = data;
                this.setDataSourceAttributes();
                this.isLoading = false;
                this.showLogs = true;
            }, error => {
                this.isLoading = false;
            });
        });
    }
}
  onDropdownChange() {
    this.tempCai = '';
  }
 
  applyFilter(event: Event, column: string): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filterPredicate = (data: IDoaLog, filter: string) => {
      const textToSearch = data[column as keyof IDoaLog] && data[column as keyof IDoaLog].toString().toLowerCase() || '';
      return textToSearch.indexOf(filter.toLowerCase()) !== -1;
    };
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
 
  downloadExcel(): void {
    this.ExcelLoading = true;
 
    const type = this.selectedOption === 'employee' ? 'emp' : 'user';
 
    this.adminService.getEmpLogsWorksheet(this.cai, type).subscribe(
      response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Logs_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.ExcelLoading = false;
      },
      error => {
        console.error('Error downloading the Excel file', error);
        this.ExcelLoading = false;
      }
    );
  }
}
